module.exports = __webpack_public_path__ + "img/cuve-simple.75497546.jpg";